import React, { Component } from 'react';
import {
    withRouter
} from 'react-router-dom';
import {
    Page,
    Text,
    Card,
    Button,
    BlockStack,
    Icon,
} from '@shopify/polaris';
import {
    LockMajor
} from '@shopify/polaris-icons';
import './index.scss';
import LightningIcon from '../../../assets/LightningIcon';

// 翻译
import Language from '../../../i18n/Language';
import utils from '../../../utils/utils';
import { connect } from 'react-redux'
import { store } from '../../../redux/store';
import FaqCardBox from '../../../components/FaqCardBox';
import FooterTrustHelp from '../../../components/FooterTrustHelp';
const t = Language;
class SpeedOptimization extends Component {
    state = {
        LongCard: [
            {
                id: 1,
                icon: <svg width="24" height="24" viewBox="0 0 36 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M26.0046 12.3458C26.3796 12.9254 27.1535 13.0912 27.7331 12.7161C28.3127 12.341 28.4785 11.5672 28.1034 10.9876L26.0046 12.3458ZM7.89632 10.9876C7.52126 11.5672 7.68707 12.341 8.26666 12.7161C8.84624 13.0912 9.62014 12.9254 9.9952 12.3458L7.89632 10.9876ZM24.0718 15.6431C24.427 15.0511 24.235 14.2833 23.643 13.9281C23.0511 13.5729 22.2832 13.7649 21.9281 14.3569L24.0718 15.6431ZM7.99992 29.5833H27.9999V27.0833H7.99992V29.5833ZM35.9166 21.6667V18.3333H33.4166V21.6667H35.9166ZM0.083252 18.3333V21.6667H2.58325V18.3333H0.083252ZM17.9999 0.416666C8.10482 0.416666 0.083252 8.43823 0.083252 18.3333H2.58325C2.58325 9.81894 9.48553 2.91667 17.9999 2.91667V0.416666ZM35.9166 18.3333C35.9166 8.43823 27.895 0.416666 17.9999 0.416666V2.91667C26.5143 2.91667 33.4166 9.81894 33.4166 18.3333H35.9166ZM27.9999 29.5833C32.3722 29.5833 35.9166 26.0389 35.9166 21.6667H33.4166C33.4166 24.6582 30.9915 27.0833 27.9999 27.0833V29.5833ZM7.99992 27.0833C5.00838 27.0833 2.58325 24.6582 2.58325 21.6667H0.083252C0.083252 26.0389 3.62766 29.5833 7.99992 29.5833V27.0833ZM14.2499 28.3333C14.2499 26.2623 15.9289 24.5833 17.9999 24.5833V22.0833C14.5481 22.0833 11.7499 24.8816 11.7499 28.3333H14.2499ZM17.9999 24.5833C20.071 24.5833 21.7499 26.2623 21.7499 28.3333H24.2499C24.2499 24.8816 21.4517 22.0833 17.9999 22.0833V24.5833ZM17.9999 7.91667C22.0666 7.91667 24.4295 9.9118 26.0046 12.3458L28.1034 10.9876C26.1918 8.03353 23.1203 5.41667 17.9999 5.41667V7.91667ZM9.9952 12.3458C11.5702 9.9118 13.9331 7.91667 17.9999 7.91667V5.41667C12.8794 5.41667 9.80791 8.03353 7.89632 10.9876L9.9952 12.3458ZM19.0718 23.9765L24.0718 15.6431L21.9281 14.3569L16.9281 22.6902L19.0718 23.9765Z" fill="#0FA958" />
                </svg>,
                title: 'Site Speed Up',
                desc: 'Maximize your website loading speed, help you obtain higher rankings and better customer satisfaction.',
                url: '/speedOpt/site-speedup',
                btn: 'View more',
                btnType: 1, // 1 - primary
                img: '/indoorImg/new/speed_up.png',
                plan: 1,
                type: 1,
            }
        ],
        ShortCard: [
            {
                id: 2,
                icon: <svg width="24" height="24" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M27.5 0.213272H7.5C6.83696 0.213272 6.20107 0.476664 5.73223 0.945505C5.26339 1.41435 5 2.05023 5 2.71327V5.21327H2.5C1.83696 5.21327 1.20107 5.47666 0.732233 5.94551C0.263392 6.41435 0 7.05023 0 7.71327V27.7133C0 28.3763 0.263392 29.0122 0.732233 29.481C1.20107 29.9499 1.83696 30.2133 2.5 30.2133H22.5C23.163 30.2133 23.7989 29.9499 24.2678 29.481C24.7366 29.0122 25 28.3763 25 27.7133V25.2133H27.5C28.163 25.2133 28.7989 24.9499 29.2678 24.481C29.7366 24.0122 30 23.3763 30 22.7133V2.71327C30 2.05023 29.7366 1.41435 29.2678 0.945505C28.7989 0.476664 28.163 0.213272 27.5 0.213272ZM7.5 2.71327H27.5V13.5539L24.8906 10.9445C24.4218 10.476 23.7862 10.2129 23.1234 10.2129C22.4607 10.2129 21.825 10.476 21.3562 10.9445L9.58906 22.7133H7.5V2.71327ZM22.5 27.7133H2.5V7.71327H5V22.7133C5 23.3763 5.26339 24.0122 5.73223 24.481C6.20107 24.9499 6.83696 25.2133 7.5 25.2133H22.5V27.7133ZM27.5 22.7133H13.125L23.125 12.7133L27.5 17.0883V22.7133ZM13.75 12.7133C14.4917 12.7133 15.2167 12.4933 15.8334 12.0813C16.4501 11.6692 16.9307 11.0836 17.2145 10.3983C17.4984 9.71311 17.5726 8.95911 17.4279 8.23168C17.2833 7.50425 16.9261 6.83607 16.4017 6.31162C15.8772 5.78717 15.209 5.43002 14.4816 5.28533C13.7542 5.14063 13.0002 5.21489 12.3149 5.49872C11.6297 5.78255 11.044 6.2632 10.632 6.87988C10.2199 7.49657 10 8.22159 10 8.96327C10 9.95783 10.3951 10.9117 11.0983 11.6149C11.8016 12.3182 12.7554 12.7133 13.75 12.7133ZM13.75 7.71327C13.9972 7.71327 14.2389 7.78658 14.4445 7.92393C14.65 8.06129 14.8102 8.25651 14.9049 8.48492C14.9995 8.71333 15.0242 8.96466 14.976 9.20714C14.9278 9.44961 14.8087 9.67234 14.6339 9.84716C14.4591 10.022 14.2363 10.141 13.9939 10.1893C13.7514 10.2375 13.5001 10.2127 13.2716 10.1181C13.0432 10.0235 12.848 9.8633 12.7107 9.65774C12.5733 9.45217 12.5 9.2105 12.5 8.96327C12.5 8.63175 12.6317 8.31381 12.8661 8.07939C13.1005 7.84497 13.4185 7.71327 13.75 7.71327Z" fill="#0FA958" />
                </svg>,
                title: 'Image Optimization',
                desc: 'Reduce the file size of your images as much as possible without sacrificing quality, and your page load times will be short.',
                url: '/speedOpt/PageSpeed',
                btn: 'Optimize images',
                btnType: 1, // 1 - primary
                img: '/indoorImg/new/ImageOpt.png',
                plan: 1,
                type: 1,

            },
            {
                id: 3,
                icon: <svg width="24" height="24" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.9958 0.426544C23.3102 0.492052 29.9713 6.92729 30 15.5793C30.0262 23.5103 23.5477 30.5973 14.6187 30.4234C6.47416 30.2646 -0.178345 23.6304 0.00364734 14.9681C0.164546 7.31741 6.40654 0.505646 14.9958 0.426544ZM11.8364 17.695C12.3698 17.695 12.9033 17.6961 13.4366 17.6944C13.6916 17.6936 13.8514 17.7512 13.7919 18.0709C13.6612 18.774 13.5541 19.4813 13.4392 20.1868C13.2228 21.5169 13.007 22.8472 12.792 24.1777C12.7714 24.3045 12.7051 24.4399 12.8685 24.5275C13.1465 24.6762 13.9068 24.4868 14.0639 24.2243C16.0569 20.8985 18.049 17.5721 20.0399 14.2451C20.4536 13.5531 20.2366 13.1789 19.4251 13.1728C18.4918 13.1662 17.5582 13.1662 16.6247 13.1728C16.3348 13.1746 16.1378 13.1362 16.2076 12.7569C16.4159 11.6285 16.6061 10.4968 16.7969 9.36526C16.946 8.47932 17.0889 7.59235 17.2257 6.7044C17.246 6.57198 17.3267 6.40792 17.1108 6.3294C16.886 6.26411 16.6465 6.27027 16.4253 6.34702C16.2041 6.42377 16.0123 6.56732 15.8762 6.75784C14.3431 9.3111 12.8111 11.8651 11.2804 14.4198C10.8184 15.1905 10.3425 15.9532 9.90237 16.7364C9.57248 17.3229 9.78905 17.6862 10.4365 17.6932C10.903 17.6982 11.3699 17.6943 11.8367 17.6952L11.8364 17.695Z" fill="#0FA958" />
                </svg>,
                title: 'AMP',
                desc: 'Faster mobile site speed will help your site rank better in mobile search results.',
                url: '/speedOpt/seo-ant-amp',
                btn: 'Activate AMP',
                img: '/indoorImg/new/amp.png',
                plan: 3,
                type: 1,
            },
        ],
        questionList: {
            so_what_impact: {
                title: "What is the impact of speed optimization on SEO?",
                tag: [
                    "Speed optimization is crucial for SEO. Website loading speed is a key factor that affects both user experience and search engine rankings. Faster loading times not only improve user satisfaction and reduce bounce rates, but they also directly impact SEO rankings. Search engines like Google consider website speed as part of their ranking algorithms, so optimizing speed can enhance your website's ranking and increase traffic.",
                ]
            },
            so_long_speed: {
                title: "How long will it take to see results after using the speed optimization feature?",
                tag: ["The effects are usually immediate. You can use  PageSpeed Insights to reassess the loading times of your optimized pages and observe changes in website traffic and user behavior improvements."]
            },
        }, // 问题列表
    }

    // 跳转
    jumpUrl = (url) => {
        utils.routeJump(this, url);
    }

    render() {
        const {
            LongCard,
            ShortCard,
            questionList,

        } = this.state;

        // 判断是否shopify内嵌模式
        const shopifyMode = store.getState().public.isShowTopMenu || 1;

        // 等级
        const level = store.getState().public.level;

        // 常见问题
        const FrequentAsk = <FaqCardBox FaqList={questionList} />

        // 底部
        const FooterHelpBox = <FooterTrustHelp />

        // 最终页面
        const lockIcon = (plan = 1) => {
            return <div className='PAY_ICON_NEW'>
                <Icon source={LockMajor} tone="base" /> {plan === 2 ? t("Pro plan") : t("Pre plan")}
            </div>
        }
        const pageContent = <Page
            title={shopifyMode ? t("Speed Optimization") : ''}
        >
            <title>SEOAnt - Speed Optimization</title>
            <div className={`speed_optimization`}>
                <BlockStack gap={400}>
                    {
                        LongCard.map(item => {
                            return <Card padding={0} key={item.title}>
                                <div className='LongCard_Info'>
                                    <div className='LC_img'><img alt='' src={item.img} /></div>
                                    <div className='LC_mes'>
                                        <div className='flex_layout'>
                                            <Text variant="headingMd" as="h2">{t(item.title)}</Text>
                                            {(item.plan === 1 || (item.plan === 2 && level === 2) || level === 3) ? null : lockIcon(item.plan)}
                                        </div>
                                        <BlockStack gap={400}>
                                            <Text as="p" fontWeight="regular">{t(item.desc)}</Text>
                                            <div>
                                                <Button onClick={() => this.jumpUrl(item.url)} icon={LightningIcon} variant='primary'>{t("To speed up")}</Button>
                                            </div>
                                        </BlockStack>
                                    </div>
                                </div>
                            </Card>
                        })
                    }
                    <div className='ShortCard'>
                        {
                            ShortCard.map(item => {
                                return <Card key={item.title}>
                                    <div className='ShortCard_Info'>
                                        <div className='SC_img'><img alt='' src={item.img} /></div>
                                        <div className='SC_mes'>
                                            <div className='SC_info'>
                                                <BlockStack gap={200}>
                                                    <div className='flex_layout'>
                                                        <Text variant="headingMd" as="h2">{t(item.title)}</Text>
                                                        {(item.plan === 1 || (item.plan === 2 && level === 2) || level === 3) ? null : lockIcon(item.plan)}
                                                    </div>
                                                    <Text as="p" fontWeight="regular">{t(item.desc)}</Text>
                                                </BlockStack>
                                            </div>
                                            <div>
                                                <Button onClick={() => this.jumpUrl(item.url)} variant={Boolean(item?.btnType) && "primary"}>{t(item.btn)}</Button>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            })
                        }
                    </div>
                    {FrequentAsk}
                </BlockStack>
            </div>

            {FooterHelpBox}
        </Page>

        return pageContent;
    }
}

const mapStateToProps = state => {
    return state;
}

SpeedOptimization = connect(
    mapStateToProps,
)(SpeedOptimization);

export default withRouter(SpeedOptimization);